<rc-order [isSuccessful]="true">
  <span order-heading>
    <span class="material-icons">check_circle</span> Comanda {{orderId ? '#' + orderId : ''}} plasată cu succes
  </span>
  <span order-content>
    Plata a fost confirmată.<br />
    În cel mai scurt timp, vei fi contactat telefonic de un operator, pentru confirmarea și validarea comenzii. (program operator: 9-17 de luni până vineri).
  </span>

  <span thanks-content>
     Detaliile comenzii, precum și detaliile de plată le vei primi pe adresa de e-mail.
  </span>
  <span thanks-heading>
    Mulțumim că ai ales ExpertTabla.ro!
  </span>
</rc-order>
